import { useState, type FormEvent } from 'react';

import { isTwoFactorChallenge, useLogin, useVerifyTwoFactor } from '../features/auth/useAuth';

/**
 * ВХОД В ЛАЙТ (`s608`, Ф1) — тот же логин сотрудника, что в панели.
 *
 * ⛔ СВОЙ ЭКРАН ВХОДА, А НЕ ЭКРАН ПАНЕЛИ. У панели вход нарядный: своя тема,
 * подвижный фон, отдельный набор шрифтов — три четверти веса ради одной формы.
 * Дежурный открывает лайт на телефоне между клиентками, часто на слабой сети,
 * и платить за красоту входа секундами загрузки здесь нечем.
 *
 * ⛔ ВХОД ОБЩИЙ. Кука выписана на всю систему, поэтому вошедший в панели
 * попадает сюда без пароля, и наоборот. Заводить лайту свой вход значило бы
 * второй раз спрашивать то же самое.
 */
export function VhodLayt() {
  const [login, setLogin] = useState('');
  const [parol, setParol] = useState('');
  const [kod, setKod] = useState('');
  const [vyzov, setVyzov] = useState<string | null>(null);
  const [otkaz, setOtkaz] = useState<string | null>(null);

  const vhod = useLogin();
  const proverka = useVerifyTwoFactor();

  const zanyat = vhod.isPending || proverka.isPending;

  const otpravit = (e: FormEvent) => {
    e.preventDefault();
    setOtkaz(null);

    if (vyzov !== null) {
      proverka.mutate(
        { challenge_id: vyzov, code: kod.trim() },
        { onError: () => setOtkaz('Код не подошёл. Попробуйте ещё раз.') },
      );

      return;
    }

    vhod.mutate(
      { login: login.trim(), password: parol, remember: true },
      {
        onSuccess: (rezultat) => {
          if (isTwoFactorChallenge(rezultat)) {
            setVyzov(rezultat.challenge_id);
          }
        },
        onError: () => setOtkaz('Не вошли. Проверьте логин и пароль.'),
      },
    );
  };

  return (
    <div className="ops-skin flex h-[100dvh] flex-col justify-center bg-ops-bg px-5 text-ops-text">
      {/*
        ⛔ БЕЗ ПОДПИСИ ПОД ЗАГОЛОВКОМ (§31.7). Здесь стояла строка «вход тот же,
        что в рабочей системе» — ровно тот мелкий поясняющий текст, который
        правило запрещает: два поля и кнопка объясняют себя сами, а подпись
        читает только тот, кто и так знает.
      */}
      <h1 className="mb-5 text-ops-h2 font-semibold">Переписка</h1>

      <form onSubmit={otpravit} className="flex flex-col gap-3">
        {vyzov === null ? (
          <>
            <input
              type="text"
              inputMode="email"
              autoComplete="username"
              autoCapitalize="none"
              value={login}
              onChange={(e) => setLogin(e.target.value)}
              placeholder="Почта или телефон"
              className="w-full rounded-ops-md border border-ops-border bg-ops-surface px-3 py-3 text-ops-body outline-none focus:border-ops-primary"
            />
            <input
              type="password"
              autoComplete="current-password"
              value={parol}
              onChange={(e) => setParol(e.target.value)}
              placeholder="Пароль"
              className="w-full rounded-ops-md border border-ops-border bg-ops-surface px-3 py-3 text-ops-body outline-none focus:border-ops-primary"
            />
          </>
        ) : (
          <input
            type="text"
            inputMode="numeric"
            autoComplete="one-time-code"
            value={kod}
            onChange={(e) => setKod(e.target.value)}
            placeholder="Код подтверждения"
            className="w-full rounded-ops-md border border-ops-border bg-ops-surface px-3 py-3 text-center text-ops-h2 tracking-[0.3em] outline-none focus:border-ops-primary"
          />
        )}

        {otkaz !== null && <p className="text-ops-caption text-ops-danger">{otkaz}</p>}

        <button
          type="submit"
          disabled={zanyat}
          className="w-full rounded-ops-md bg-ops-primary px-3 py-3 text-ops-body font-semibold text-white disabled:opacity-50"
        >
          {zanyat ? 'Секунду…' : vyzov === null ? 'Войти' : 'Подтвердить'}
        </button>
      </form>
    </div>
  );
}
